import React, { useState } from 'react';

import { MainView, NoAccessView } from '@repo/ui/Views';
import { POLICIES } from '@/lib/Authorization';
import { useUser } from '@repo/hooks/useUser';

import OptOutsFilter from '../components/OptOutsFilter';
import { OptOutsTable } from '../components/OptOutsTable';
import MessagingTabNav from '../components/MessagingTabNav';

import { SelectInputOptions } from '@repo/types/Types';
import { PAGE_SCHEMA } from '@repo/ui/Pagination';
import { z } from 'zod';
import { getNonEmpty } from '@repo/util/nonEmpty';
import { toQueryList } from '@repo/util/toQueryList';
import { combineDateRange } from '@repo/util/combineDateRange';
import { useZodQuery } from '@repo/hooks/useZodQuery';
import { coerce } from '@repo/util/coerceForTable';
import { Form } from '@repo/ui/Form';

import { coerceValue } from '@repo/util/coerceValueForQuery';

const OptOutsPage = () => {
  const user = useUser();

  const TYPES: SelectInputOptions = [
    { label: '', value: '' },
    { label: 'Account', value: 'ACCOUNT' },
    { label: 'CSP Brand', value: 'CSP_BRAND' },
    { label: 'CSP Campaign', value: 'CSP_CAMPAIGN' },
    { label: 'Host DID', value: 'HOST_DID' },
  ] as const;

  const today = new Date();
  const oneWeekAgoDate = new Date();
  oneWeekAgoDate.setDate(today.getDate() - 7);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [currentDate, setCurrentDate] = useState<Date>(today);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [oneWeekAgo, setOneWeekAgo] = useState<Date>(oneWeekAgoDate);

  const OPT_OUTS_QUERY_SCHEMA = PAGE_SCHEMA.extend({
    type: z.enum(getNonEmpty(TYPES.map((t) => t.value))).default(''),
    remote_number: z.string().default(''),
    host_number: z.string().default(''),
    keyword: z.string().default(''),
    tcr_brand_id: z.string().default(''),
    tcr_campaign_id: z.string().default(''),
    start: z.coerce.date().optional().default(oneWeekAgo),
    end: z.coerce.date().optional().default(currentDate),
  });

  const filter = useZodQuery({
    schema: OPT_OUTS_QUERY_SCHEMA,
    ignoreList: ['page'],
    coerce,
  });

  const { page, start, end, ...queryFields } = filter.queryValues;

  const queryList = [
    ...toQueryList(
      {
        ...queryFields,
        inserted_at: combineDateRange(start, end),
      },
      coerceValue,
      ['host_number', 'remote_number', 'keyword']
    ),
  ];

  return POLICIES['messaging_optout_items:index'](user) ? (
    <MainView title="Messaging">
      <MessagingTabNav />
      <Form {...filter} variant="horizontal">
        <OptOutsFilter TYPES={TYPES} />
      </Form>
      <OptOutsTable queryList={queryList} page={page} filter={filter} />
    </MainView>
  ) : (
    <NoAccessView />
  );
};

export default OptOutsPage;
